<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <h3>{{ "i18n.base.changePassword.header" | translate }}</h3>
    <div class="e-card">
      <div class="e-card-content">
        <form id="changePasswordForm" [formGroup]="changePasswordForm" autocomplete="on">
          <div class="form-group">
            <label for="oldPassword">{{ "i18n.base.changePassword.oldPassword" | translate }}</label>
            <app-password-input inputId="oldPassword"
                                name="oldPassword"
                                autocomplete="current-password"
                                formControlName="oldPassword">
            </app-password-input>
            <app-error-messages [control]="oldPasswordControl"></app-error-messages>
          </div>
          <div class="form-group">
            <label for="newPassword">{{ "i18n.base.changePassword.newPassword" | translate }}</label>
            <app-password-input inputId="newPassword"
                                name="newPassword"
                                autocomplete="new-password"
                                formControlName="newPassword">
            </app-password-input>
            <app-error-messages [control]="newPasswordControl"></app-error-messages>
          </div>
          <div class="form-group">
            <label for="newPasswordConfirm">{{ "i18n.base.changePassword.newPasswordConfirm" | translate }}</label>
            <app-password-input inputId="newPasswordConfirm"
                                name="newPasswordConfirm"
                                autocomplete="new-password"
                                formControlName="newPasswordConfirm">
            </app-password-input>
            <app-error-messages [control]="newPasswordConfirmControl"></app-error-messages>
          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary" (click)="changePassword()"  [disabled]="!changePasswordForm.valid">
              @if (loading) {
                <div class="spinner-border spinner-border-sm me-3" role="status"></div>
              }
              {{ "i18n.base.changePassword.changePassword" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
